import { Box, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CautionIcon } from "src/theme/overrides/CustomIcons";

const NoDataBox = ({
    noDataLabel,
    sx,
    sxInner,
}: {
    noDataLabel?: string;
    sx?: SxProps;
    sxInner?: SxProps;
}) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ px: 3, pb: 4, ...sx }}>
            <Box
                sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    fontStyle: "italic",
                    mt: 2,
                    ...sxInner,
                }}
            >
                <CautionIcon sx={{ color: "text.secondary" }} />
                <Typography variant="body2">{noDataLabel || t("shared.noData")}</Typography>
            </Box>
        </Box>
    );
};
export default NoDataBox;
